var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUk = function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uk_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uk_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uk_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 6h30v20H1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M17.875 6h-3.75v8.125H1v3.75h13.125V26h3.75v-8.125H31v-3.75H17.875z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24.073 19.478 31 23.326v-3.848zm-4.812 0L31 26v-1.844l-8.42-4.678zM27.873 26l-8.612-4.785V26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.26 19.478 31 26v-1.844l-8.42-4.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M19.26 19.478 31 26v-1.844l-8.42-4.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M6.293 19.478 1 22.418v-2.94zm6.446.83V26H2.494z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M9.42 19.478 1 24.156V26l11.74-6.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M7.927 12.522 1 8.674v3.848zm4.812 0L1 6v1.844l8.42 4.678zM4.127 6l8.612 4.785V6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.74 12.522 1 6v1.844l8.42 4.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12.74 12.522 1 6v1.844l8.42 4.678z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M25.707 12.522 31 9.58v2.94zm-6.446-.83V6h10.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M22.58 12.522 31 7.844V6l-11.74 6.522z"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#D7D7D7",
    strokeWidth: 0.5,
    d: "M9.4 6.25h13.2c1.124 0 1.952 0 2.607.054.651.053 1.109.158 1.495.355a3.75 3.75 0 0 1 1.64 1.639c.196.386.301.844.354 1.495.054.655.054 1.483.054 2.607v7.2c0 1.124 0 1.952-.054 2.607-.053.651-.158 1.109-.355 1.495a3.75 3.75 0 0 1-1.639 1.64c-.386.196-.844.301-1.495.354-.655.054-1.483.054-2.607.054H9.4c-1.124 0-1.952 0-2.607-.054-.651-.053-1.109-.158-1.495-.355a3.75 3.75 0 0 1-1.64-1.639c-.196-.386-.301-.844-.354-1.495-.054-.655-.054-1.483-.054-2.607v-7.2c0-1.124 0-1.952.054-2.607.053-.651.158-1.109.355-1.495a3.75 3.75 0 0 1 1.639-1.64c.386-.196.844-.301 1.495-.354.655-.054 1.483-.054 2.607-.054Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uk_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 12.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 6 7.16 6 9.4 6h13.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C29 9.04 29 10.16 29 12.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C25.96 26 24.84 26 22.6 26H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 22.96 3 21.84 3 19.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uk_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 6h30v20H1z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "uk_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1 6h30v20H1z"
  })))));
};
export default SvgUk;